module.exports = __webpack_public_path__ + "img/4.913dbe79.png";